import { clearApptParams, clearGroupParams, clearNoteParam } from './apptLink.js';
import { writeContactParam } from './contactUrl.js';

/**
 * ehr#622 (reopened 10-24) - switching who the EHR shows (View as, Back to my account, or the
 * dev user switch) drops the chart links in the URL: the open client, the note or session to
 * open there, the group workspace. They belonged to the person viewed before; read again for the
 * next person they opened a chart that isn't theirs ("This client is not shared with you").
 *
 * The page body is also mounted fresh for the new person (App keys it on the user), so every
 * list and count (Progress Notes' To write, To review, My drafts...) is that person's.
 */
export function clearChartLinks(): void {
  clearApptParams();
  clearNoteParam();
  clearGroupParams();
  writeContactParam(null);
}
